import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { lazy } from "react";

import Login from "./pages/Accounts/Login";
import { DynamicRoute } from "./utils/routes/DynamicRoute";
import Layout from "./components/Layout/Layout";
import MLogin from "./pages/Mobile/Login";
import Main from "./pages/Mobile/Main";
import CodeMng from "./pages/Common/CodeMng";
import UserMng from "./pages/Common/UserMng";
import GroupMng from "./pages/Common/GroupMng";
import MenuMng from "./pages/Common/MenuMng";
import AuthMng from "./pages/Common/AuthMng";
import AuthMenuMng from "./pages/Common/AuthMenuMng";
import AuthGroupMng from "./pages/Common/AuthGroupMng";
import GroupUserMng from "./pages/Common/GroupUserMng";
import Board from "./pages/Common/Board";
import CameraMng from "./pages//Common/CameraMng";
import InspectionProgressReg from "./pages/VideoMng/InspectionProgressReg";
import BoardInfo from "./pages/VideoMng/BoardInfo";
import InsepctionWaitMng from "./pages/DomesticScrapMng/InsepctionWaitMng";
import WaitVehicleMng from "./pages/DomesticScrapMng/WaitVehicleMng";
import SeaTransportMng from "./pages/DomesticScrapMng/SeaTransportMng";
import ScrapDailyTotal from "./pages/DomesticScrapMng/ScrapDailyTotal";
import ScrapTotalList from "./pages/DomesticScrapMng/ScrapTotalList";
import ImportVehicleMng from "./pages/ImportScrapMng/ImportVehicleMng";
import ImportScrapDailyTotal from "./pages/ImportScrapMng/ImportScrapDailyTotal";
import GradeConfirmReg from "./pages/IncomingMng/GradeConfirmReg";
import GradeCancelReg from "./pages/IncomingMng/GradeCancelReg";
import IncomingVehicleMng from "./pages/IncomingMng/IncomingVehicleMng";
import WeighingResult from "./pages/IncomingMng/WeighingResult";
import DailyWeighingResult from "./pages/DomesticScrapMng/DailyWeighingResult";
import MagnetMng from "./pages/RawMaterialMng/MagnetMng";
import BargeVehicleMng from "./pages/DomesticScrapMng/BargeVehicleMng";

const DSRouter = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route exact path={"/login"} element={<Login />} />
        <Route exact path={"/mobile/login"} element={<MLogin />} />
        <Route
          exact
          path={"/mobile/main"}
          element={
            <DynamicRoute>
              <Main />
            </DynamicRoute>
          }
        />
        <Route
          path="*"
          element={
            <>
              <Layout>
                <Routes>
                  <Route path={"/"} element={<DynamicRoute></DynamicRoute>} />

                  <Route
                    path={"/Common/CodeMng"}
                    element={
                      <DynamicRoute>
                        <CodeMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/Common/UserMng"}
                    element={
                      <DynamicRoute>
                        <UserMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/Common/GroupMng"}
                    element={
                      <DynamicRoute>
                        <GroupMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/Common/MenuMng"}
                    element={
                      <DynamicRoute>
                        <MenuMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/Common/AuthMng"}
                    element={
                      <DynamicRoute>
                        <AuthMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/Common/AuthMenuMng"}
                    element={
                      <DynamicRoute>
                        <AuthMenuMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/Common/AuthGroupMng"}
                    element={
                      <DynamicRoute>
                        <AuthGroupMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/Common/GroupUserMng"}
                    element={
                      <DynamicRoute>
                        <GroupUserMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/Common/CameraMng"}
                    element={
                      <DynamicRoute>
                        <CameraMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/VideoMng/InspectionProgressReg"}
                    element={
                      <DynamicRoute>
                        <InspectionProgressReg />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/VideoMng/BoardInfo"}
                    element={
                      <DynamicRoute>
                        <BoardInfo />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/DomesticScrapMng/InsepctionWaitMng"}
                    element={
                      <DynamicRoute>
                        <InsepctionWaitMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/DomesticScrapMng/WaitVehicleMng"}
                    element={
                      <DynamicRoute>
                        <WaitVehicleMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/DomesticScrapMng/SeaTransportMng"}
                    element={
                      <DynamicRoute>
                        <SeaTransportMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/DomesticScrapMng/ScrapDailyTotal"}
                    element={
                      <DynamicRoute>
                        <ScrapDailyTotal />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/DomesticScrapMng/ScrapTotalList"}
                    element={
                      <DynamicRoute>
                        <ScrapTotalList />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/DomesticScrapMng/DailyWeighingResult"}
                    element={
                      <DynamicRoute>
                        <DailyWeighingResult />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/DomesticScrapMng/BargeVehicleMng"}
                    element={
                      <DynamicRoute>
                        <BargeVehicleMng />
                      </DynamicRoute>
                    }
                  />

                  <Route
                    path={"/ImportScrapMng/ImportVehicleMng"}
                    element={
                      <DynamicRoute>
                        <ImportVehicleMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/ImportScrapMng/ImportScrapDailyTotal"}
                    element={
                      <DynamicRoute>
                        <ImportScrapDailyTotal />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/IncomingMng/GradeConfirmReg"}
                    element={
                      <DynamicRoute>
                        <GradeConfirmReg />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/IncomingMng/GradeCancelReg"}
                    element={
                      <DynamicRoute>
                        <GradeCancelReg />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/IncomingMng/IncomingVehicleMng"}
                    element={
                      <DynamicRoute>
                        <IncomingVehicleMng />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/IncomingMng/WeighingResult"}
                    element={
                      <DynamicRoute>
                        <WeighingResult />
                      </DynamicRoute>
                    }
                  />
                  <Route
                    path={"/RawMaterialMng/MagnetMng"}
                    element={
                      <DynamicRoute>
                        <MagnetMng />
                      </DynamicRoute>
                    }
                  />
                </Routes>
              </Layout>
            </>
          }
        />
      </Routes>
    </Router>
  );
};

export default DSRouter;

const PageImport = (path, defaultPath = "./pages") => {
  return import(defaultPath + path + "")
    .then((module) => module.default)
    .catch((error) => {
      if (/not find module/.test(error.message)) {
        return import(defaultPath + "/404").then((module) => module.default);
      }
      throw error;
    });
};

export const PageImportLazy = (path, defaultPath = "./pages") => {
  //console.log(defaultPath + path + "");
  return retryLazy(() => import(defaultPath + path + "").catch((error) => {}));
};

export const retryLazy = (componentImport) =>
  lazy(async () => {
    const pageAlreadyRefreshed = JSON.parse(
      window.localStorage.getItem("pageRefreshed") || "false"
    );
    try {
      const component = await componentImport();
      window.localStorage.setItem("pageRefreshed", "false");
      return component;
    } catch (error) {
      if (!pageAlreadyRefreshed) {
        window.localStorage.setItem("pageRefreshed", "true");
        return window.location.reload();
      }
      throw error;
    }
  });
